export enum ActionTypes{

    GET_BATCH_SUCCESS ="GET_BATCH_SUCCESS",
    GET_SECTION_SUCCESS ="GET_SECTION_SUCCESS",
    GET_TYPE_SUCCESS ="GET_TYPE_SUCCESS",
    GET_USER_SUCCESS ="GET_USER_SUCCESS",
    GET_CATEGEORY_SUCCESS ="GET_CATEGEORY_SUCCESS",
    
 
    }